<template>
  <div class="wechat-binding-index">
    <template v-if="domLoad">
      <component
        :is="bindingStatus | typeToComponentName"
        :bindingInfo="bindingInfo"
        @bindingSuccess="bindingSuccess"
      />
    </template>
    <toast ref="toast" />
  </div>
</template>

<script>
import toast from '@/components/wxchatBinding/toast.vue';
import { setBaseUrl, getWechatAppId } from '@/utils/tools';
// eslint-disable-next-line import/extensions
import bindingAccount from '@/pages/wechatBinding/bindingAccount';
// eslint-disable-next-line import/extensions
import unBindingAccount from '@/pages/wechatBinding/unBindingAccount';
import { reqWeChatBindQuery } from '@/api/wechatServiceNum';

export default {
  components: { bindingAccount, unBindingAccount, toast },
  filters: {
    /** 根据type找到组件 */
    typeToComponentName(val) {
      let componentName;
      if (val === 'wechatBindingAccount') {
        componentName = 'bindingAccount';
      } else if (val === 'wechatUnBindingAccount') {
        componentName = 'unBindingAccount';
      }
      return componentName || '';
    },
  },
  data() {
    return {
      wxInfo: {},
      bindingStatus: 'wechatBindingAccount',
      bindingInfo: {},
      domLoad: false,
    };
  },
  mounted() {
    // 判断是否在微信中
    if (!this.$root.$data.isWeiXin) {
      this.$refs.toast.toastShow({
        type: 'warn',
        text: '请在微信中打开！',
        duration: 'allTime',
      });
      return;
    }
    this.bindingStatus = this.$route.name;
    if (this.$route.query.bindingConfirm) {
      // 已查询过绑定状态时，不再进行微信授权
      this.domLoad = true;
    } else if (this.$route.query.state && this.$route.query.state === 'weixinredirect') {
      // 微信重定向后的地址
      this.domLoad = true;
      this.wxInfo = this.$route.query;
      this.weChatBindQuery(); // 查询绑定状态
    } else {
      this.wechatAuth();
    }
  },
  methods: {
    // 获取微信授权
    async wechatAuth() {
      const wechatAppId = await getWechatAppId('binding');
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wechatAppId}&redirect_uri=${setBaseUrl('default')}/ark/${this.$route.name}&response_type=code&scope=snsapi_base&state=weixinredirect&connect_redirect=1#wechat_redirect`;
    },

    // 绑定成功，到解绑页面
    bindingSuccess(val) {
      if (val.wechatBind) {
        this.$router.push({ path: '/wechatUnBindingAccount', query: { bindingConfirm: true, ...this.$route.query } });
        this.bindingInfo = val;
      }
    },

    async weChatBindQuery() {
      // 6061 wx code异常
      // 查询绑定状态
      const wechatAppId = await getWechatAppId('binding');
      const response = await reqWeChatBindQuery(wechatAppId, this.wxInfo.code);
      if (response.code === 0) {
        this.bindingInfo = response.data;
        if (this.bindingInfo.wechatBind) {
          // 如果已绑定，且当前在绑定页面，则跳转到解绑页面
          if (this.$route.name !== 'wechatUnBindingAccount') {
            this.$router.replace({ path: '/wechatUnBindingAccount', query: { bindingConfirm: true, ...this.$route.query } });
          }
        } else {
          // 如果未绑定，且当前在绑定页面，则跳转到绑定页面
          this.$router.replace({ path: '/toBind', query: { bindingConfirm: true, ...this.$route.query } });
        }
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 路由进入时，确认页面需要显示的组件
      // eslint-disable-next-line no-param-reassign
      vm.bindingStatus = vm.$route.name;
    });
  },
};
</script>
